import { render } from "./WelcomeLink.vue?vue&type=template&id=26ad740e"
import script from "./WelcomeLink.vue?vue&type=script&lang=js"
export * from "./WelcomeLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.7.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__